export const ADD_RETRY_REQUEST = '@@appConfig/ADD_RETRY_REQUEST';
export const CLEAR_RETRY_REQUESTS = '@@appConfig/CLEAR_RETRY_REQUESTS';

export const addRetryRequest = requestConfig => ({
    type: ADD_RETRY_REQUEST,
    payload: { requestConfig },
});
